"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemImageAreaSkeleton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var _1 = require("./");
/**
 * アイテムサムネイル用コンポーネント（長方形・正方形共通）
 * 60px x 96pxの枠の中に、画像を横幅を100%で合わせてセンタリングする
 *
 * @param fullWidth
 * @param size
 */
var ItemImageAreaSkeleton = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    return ((0, jsx_runtime_1.jsx)(material_1.Skeleton, __assign({ variant: "rectangular" }, (0, _1.calculateSize)(size))));
};
exports.ItemImageAreaSkeleton = ItemImageAreaSkeleton;
